"use client";

import { useEffect } from "react";
import { supabase } from "@/lib/supabase";
import { useRouter, usePathname } from "next/navigation";

export default function SessionGuard() {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    // Don't run on login page (avoid loops)
    if (pathname === "/login") return;

    const checkSession = async () => {
      // 1. Get current logged in user (use getSession for speed — no network call)
      const {
        data: { session },
      } = await supabase.auth.getSession();
      if (!session?.user) return;

      const user = session.user;

      // 2. Get the token stored in THIS browser's memory
      const localToken = localStorage.getItem("smartdwara_session_token");

      // If we don't have a local token yet (legacy session), ignore or force logout.
      // For now, we only enforce if localToken exists.
      if (!localToken) return;

      console.log("🛡️ Session Guard Active for:", user.email);

      // 3. Subscribe to Realtime Changes on MY profile row
      const channel = supabase
        .channel(`session_guard_${user.id}`)
        .on(
          "postgres_changes",
          {
            event: "UPDATE",
            schema: "public",
            table: "profiles",
            filter: `id=eq.${user.id}`,
          },
          async (payload) => {
            const newDbToken = payload.new.session_token;

            // 4. THE KILL SWITCH 💀
            // If the DB says "Token B", but I have "Token A"...
            if (newDbToken && newDbToken !== localToken) {
              console.warn(
                "💀 Kill Switch Activated: Another device logged in.",
              );

              await supabase.auth.signOut();
              localStorage.removeItem("smartdwara_session_token");

              // Kick them out immediately
              router.replace("/login?error=session_expired");
            }
          },
        )
        .subscribe();

      return () => {
        supabase.removeChannel(channel);
      };
    };

    checkSession();
  }, [router, pathname]);

  return null; // This component is invisible
}
